export default "__VITE_ASSET__BJnNwicN__"